import { ReactComponent as Crate } from "./crate.svg";
import { ReactComponent as Custom } from "./custom.svg";
import { ReactComponent as Down } from "./down.svg";
import { ReactComponent as DropIt } from "./dropit.svg";
import { ReactComponent as Fetch } from "./fetch.svg";
import { ReactComponent as Good } from "./good.svg";
import { ReactComponent as Guard } from "./guard.svg";
import { ReactComponent as ItsOkay } from "./itsokay.svg";
import { ReactComponent as Jump } from "./jump.svg";
import { ReactComponent as LeaveIt } from "./leaveit.svg";
import { ReactComponent as No } from "./no.svg";
import { ReactComponent as Off } from "./off.svg";
import { ReactComponent as Quiet } from "./quiet.svg";
import { ReactComponent as Sit } from "./sit.svg";
import { ReactComponent as Speak } from "./speak.svg";
import { ReactComponent as Stand } from "./stand.svg";
import { ReactComponent as Stay } from "./stay.svg";

export default {
  stand: {
    name: "stand",
    icon: Stand
  },
  sit: {
    name: "sit",
    icon: Sit
  },
  down: {
    name: "down",
    icon: Down
  },
  custom: {
    name: "custom",
    icon: Custom
  },
  crate: {
    name: "crate",
    icon: Crate
  },
  good: {
    name: "good",
    icon: Good
  },
  speak: {
    name: "speak",
    icon: Speak
  },
  stay: {
    name: "stay",
    icon: Stay
  },
  leave_it: {
    name: "leave_it",
    icon: LeaveIt
  },
  drop_it: {
    name: "drop_it",
    icon: DropIt
  },
  fetch: {
    name: "fetch",
    icon: Fetch
  },
  guard: {
    name: "guard",
    icon: Guard
  },
  its_okay: {
    name: "its_okay",
    icon: ItsOkay
  },
  jump: {
    name: "jump",
    icon: Jump
  },
  no: {
    name: "no",
    icon: No
  },
  off: {
    name: "off",
    icon: Off
  },
  quiet: {
    name: "quiet",
    icon: Quiet
  }
};
